import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import SelectIncubator from '../SelectIncubator';
import CompentCustom from './CompentCustom';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.current = 1;
  }

  callback = key => {};

  handleIncuChange = e => {
    browserHistory.replace(`/incubator/one/${e}`);
  };

  render() {
    return (
      <div>
        <SelectIncubator onChange={this.handleIncuChange} />
        <CompentCustom />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/custom/Index.js